/* Created by Interactive 63 - https://interactive63.com */
/**
 * A small SVG preview of path data, fitted to its own bounds. Used for the shape in the
 * Inspector, in the paste dialog, and in the grid of shapes from another file.
 */
import { pathBounds } from '../../core/morph/bounds';
import { svgEl } from '../ui/dom';

/** Draws path data in a square box. Unreadable data gives an empty box. */
export function shapeThumbnail(d: string, size = 36): SVGSVGElement {
  const box = d === '' ? null : pathBounds(d);
  const pad = box ? Math.max(box.x1 - box.x0, box.y1 - box.y0, 1) * 0.08 : 0;
  const viewBox = box
    ? `${box.x0 - pad} ${box.y0 - pad} ${box.x1 - box.x0 + pad * 2} ${box.y1 - box.y0 + pad * 2}`
    : '0 0 1 1';
  const svg = svgEl('svg', {
    class: 'shape-thumbnail',
    viewBox,
    width: size,
    height: size,
    'aria-hidden': 'true',
    preserveAspectRatio: 'xMidYMid meet',
  });
  if (box) {
    svg.append(
      svgEl('path', {
        d,
        fill: 'currentColor',
        'fill-opacity': 0.25,
        stroke: 'currentColor',
        'stroke-width': Math.max(box.x1 - box.x0, box.y1 - box.y0) / 40,
        'vector-effect': 'none',
      }),
    );
  }
  return svg;
}
